import { useTranslation } from 'react-i18next'

import Button from '@mui/material/Button'
import Portal from '@mui/material/Portal'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { useDiagnosticLayout } from '@/layouts/diagnostic/DiagnosticLayout'
import Dictaphone from '@/pages/diagnostic/containers/Dictaphone'

type TopbarProps = {
  consultationId?: string
  hasLicense: boolean
  onCloseConsultation: () => void
}

export function Topbar({ consultationId, hasLicense, onCloseConsultation }: TopbarProps) {
  const { t } = useTranslation()
  const { topbarContentContainer } = useDiagnosticLayout()

  return (
    <Portal container={topbarContentContainer}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ flex: 1 }}>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
          <Stack direction="column">
            <Typography variant="h1" sx={{ color: (theme) => theme.palette.common.white, fontSize: '16px', fontWeight: 500 }}>
              {t(`page.localConsultation.title`)}
            </Typography>
          </Stack>
        </Stack>
        <Stack direction="row" justifyContent="end" alignItems="center" spacing={2}>
          {hasLicense && <Dictaphone consultationId={consultationId} />}
          <Button
            color="error"
            onClick={onCloseConsultation}
            size="small"
            variant="contained"
            sx={{
              borderRadius: '17px',
              color: '#FFF',
              fontSize: '14px',
              lineHeight: '16px',
              padding: '10px 15px',
            }}
          >
            {t(`page.localConsultation.topbar.quitConsultationButton.label`)}
          </Button>
        </Stack>
      </Stack>
    </Portal>
  )
}
